import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { UrlBuilder } from '../utils/url-builder';

enum ApiEndpoint {
  GetUpdates = '/app-updates',
  GetUserUpdateDismissed = '/app-updates/:uuid',
  SetUserUpdateDismissed = '/app-updates/:uuid/dismiss',
}

export interface AppUpdate {
  uuid: string;
  targetVersion: string;
  isBlocker: boolean;
}

@Injectable({ providedIn: 'root' })
export class AppUpdateProvider {
  constructor(private http: HttpClient) {}

  setUserUpdateDismissed(uuid: string): Observable<void> {
    const url = new UrlBuilder(ApiEndpoint.SetUserUpdateDismissed).setUrlParams({ uuid }).getUrl();

    return this.http.post<void>(environment.usersBaseUrl + url, {});
  }

  getUserUpdateDismissed(uuid: string): Observable<boolean> {
    const url = new UrlBuilder(ApiEndpoint.GetUserUpdateDismissed).setUrlParams({ uuid }).getUrl();

    return this.http.get<{ dismissed: boolean }>(environment.usersBaseUrl + url).pipe(map(response => response.dismissed));
  }

  getAppUpdates(): Observable<Array<AppUpdate>> {
    const url = new UrlBuilder(ApiEndpoint.GetUpdates).getUrl();

    return this.http.get<Array<AppUpdate>>(environment.settingsBaseUrl + url);
  }
}
